import {
  acaoDetalheSobDemanda, componenteSobDemanda, telaSobDemanda, type AcaoDetalhe, type PropsResumoFormulario, type PropsSecaoDetalhe, type ResumoFormulario, type SecaoDetalhe,
  type TelaRotina,
} from '../tipoTelaRotina';

export const telasFAT: Record<string, TelaRotina> = {
  'fat/painel': telaSobDemanda(() => import('../../../modulos/FAT/PainelComercial'), 'PainelComercial'),
  'fat/reprocessamento': telaSobDemanda(() => import('../../../modulos/FAT/PaginaReprocessamento'), 'PaginaReprocessamento'),
  'fat/faturamento': telaSobDemanda(() => import('../../../modulos/FAT/PaginaFaturamento'), 'PaginaFaturamento'),
};

/** Ações extras no detalhe do registro (`acoesDetalheRotina`). */
export const acoesDetalheFAT: Record<string, AcaoDetalhe> = {
  FAT060: acaoDetalheSobDemanda(() => import('../../../modulos/FAT/PreviaFiscalDoPedido'), 'PreviaFiscalDoPedido'),
};

/** Valores e impostos do pedido: cartão no detalhe e quadro ao vivo no formulário. */
export const secoesDetalheFAT: Record<string, SecaoDetalhe> = {
  FAT060: componenteSobDemanda<PropsSecaoDetalhe, 'ValoresDoPedido'>(() => import('../../../modulos/FAT/ValoresPedido'), 'ValoresDoPedido'),
};

export const resumosFormularioFAT: Record<string, ResumoFormulario> = {
  FAT060: componenteSobDemanda<PropsResumoFormulario, 'ValoresAoVivo'>(() => import('../../../modulos/FAT/ValoresPedido'), 'ValoresAoVivo'),
};
